import React,{PureComponent} from 'react';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

import AuthContext from "flexbiz-core/components/auth/Context";
import withMediaQuery from "flexbiz-core/components/withMediaQuery";
import Container from './Container';
class Home extends React.PureComponent{
  constructor(props){
    super(props);
    this.state={
      Dashboard:null
    }
  }
  async componentDidMount(){
    const {default:BottomNavigation} = await import(
      /* webpackPrefetch: true */
      /* webpackChunkName: "BottomNavigation" */
      "./BottomNavigation"
    );
    let ten_chuc_vu ="KH";
    let stock_info = (this.context.appInfo?.par||{}).stock_info||{};
    const group_user = (this.context.appInfo?.par||{}).group||{}
    //nha phan pho
    let la_npp =group_user.phan_loai=="la_npp" || (stock_info.la_kho_npp && stock_info.user_npp===this.context.userInfo.email);
    if(la_npp) ten_chuc_vu ="NPP";

    let la_nv_npp = group_user.phan_loai=="la_nv_npp" || (stock_info.la_kho_npp  && group_user.is_employee_group  && !la_npp);
    if(la_nv_npp){
      ten_chuc_vu ="NVNPP";
    }

    let la_ctv_npp = group_user.phan_loai=="la_ctv_npp" || (stock_info.la_kho_npp && ((this.context.appInfo?.par||{}).group||{}).is_partner_group && !la_nv_npp && !la_npp);
    if(la_ctv_npp){
      ten_chuc_vu ="CTVNPP";
    } 
    let la_dai_ly_npp = group_user.phan_loai=="la_dai_ly_npp" || (stock_info.la_kho_npp && ((this.context.appInfo?.par||{}).group||{}).is_agent_group && !la_ctv_npp && !la_nv_npp && !la_npp);
    if(la_dai_ly_npp) ten_chuc_vu ="DLNPP";

    let la_kh_npp = group_user.phan_loai=="la_kh_npp" || (stock_info.la_kho_npp && !la_dai_ly_npp && !la_ctv_npp && !la_nv_npp && !la_npp);
    if(la_kh_npp) ten_chuc_vu ="KHNPP";

    //chu kho
    let la_chu_kho = group_user.phan_loai=="la_chu_kho" || (stock_info.la_kho_thue && stock_info.user_cho_thue===this.context.userInfo.email  && !la_dai_ly_npp && !la_ctv_npp && !la_nv_npp && !la_npp);
    if(la_chu_kho) ten_chuc_vu ="CKHO";

    let la_ctv_kho = group_user.phan_loai=="la_ctv_kho" || (stock_info.la_kho_thue && stock_info.user_cho_thue!==this.context.userInfo.email && !la_chu_kho  && !la_dai_ly_npp && !la_ctv_npp && !la_nv_npp && !la_npp);
    if(la_ctv_kho) ten_chuc_vu ="CTVKHO";
    //cty
    let la_nv = group_user.phan_loai=="la_nv" || (!la_chu_kho && !la_ctv_kho &&   this.context.appInfo?.par && this.context.appInfo?.par.group && this.context.appInfo?.par.group.is_employee_group && !la_nv_npp && !la_npp && !la_ctv_npp && !la_dai_ly_npp && !la_kh_npp);
    if(la_nv) ten_chuc_vu ="NV";

    let la_ctv = group_user.phan_loai=="la_ctv" || (!la_chu_kho && !la_ctv_kho &&  ((this.context.appInfo?.par||{}).group||{}).is_partner_group && !la_npp && !la_nv_npp && !la_nv && !la_ctv_npp && !la_dai_ly_npp && !la_kh_npp);
    if(la_ctv) ten_chuc_vu ="CTV";

    let la_dai_ly = group_user.phan_loai=="la_dai_ly" || (!la_chu_kho && !la_ctv_kho &&  ((this.context.appInfo?.par||{}).group||{}).is_agent_group && !la_npp && !la_nv && !la_ctv && !la_nv_npp && !la_ctv_npp && !la_dai_ly_npp && !la_kh_npp);
    if(la_dai_ly) ten_chuc_vu ="DL";

    let la_kh = group_user.phan_loai=="la_kh" || (!la_chu_kho && !la_ctv_kho &&  !la_npp && !la_nv_npp && !la_nv && !la_ctv && !la_dai_ly && !la_ctv_npp && !la_dai_ly_npp && !la_kh_npp);
    
    let la_admin = (group_user.phan_loai=="admin" && this.context.appInfo?.appAdmin)

    switch(this.context.queryParams.for_agent){
      case "1":{
        if(this.context.appInfo?.app_code=="MIDOMAX"){
          const {default:Dashboard} = await import("./DashboardMidomax");
          this.setState({
            Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
          })
        }else{
          if(la_nv_npp || la_ctv_npp){
            const {default:Dashboard} = await import("./DashboardNVNPP");
            this.setState({
              Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
            })
          }else{
            if(la_admin){
              const {default:Dashboard} = await import("flexbiz-core/components/dashboard/Dashboard");
              this.setState({
                Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
              })
            }else{
              if(la_nv){
                const {default:Dashboard} = await import("./DashboardNVBH");
                this.setState({
                  Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
                })
              }else{
                const {default:Dashboard} = await import("./DashboardDaiLy");
                this.setState({
                  Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
                })
              }
            }
          }
          
        }
        break;
      }
      case "2":{
        const {default:Dashboard} = await import("./DashboardThuMua");
        this.setState({
          Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
        })
        break;
      }
      case "3":{
        const {default:Dashboard} = await import("./DashboardKH");
        this.setState({
          Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
        })
        break;
      }
      case "8":{
        const {default:Dashboard} = await import("./DashboardBDS");
        this.setState({
          Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
        })
        break;
      }
      default:{
        const {default:Dashboard} = await import("flexbiz-core/components/dashboard/Dashboard");
        this.setState({
          Dashboard,BottomNavigation,la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu
        })
      }
    }
  }
  render(){
    if(!this.state.Dashboard) return null;
    let {la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu} = this.state;
    if(this.context.queryParams.for_agent){
      return (
        <div style={{height:"100%"}}>
          <this.state.Dashboard  {...this.props} style={{paddingBottom:this.state.BottomNavigation?96:0}} 
            {...{la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu}}  id="ERP"/>
          {this.state.BottomNavigation && <this.state.BottomNavigation  history={this.props.history} code={"DASHBOARD"}/>}
        </div>
      )
    }
    return (
      <div style={{height:"100%"}}>
        <this.state.Dashboard  {...this.props} style={{paddingBottom:this.state.BottomNavigation?96:0}}  
          {...{la_npp,la_nv_npp,la_ctv_npp,la_dai_ly_npp,la_kh_npp,la_chu_kho,la_ctv_kho,la_nv,la_ctv,la_dai_ly,la_kh,ten_chuc_vu}}
          showModules={this.props.mediaQueryMatches} defaultReports ={this.context.config.defaultDBReports} overviewCode={this.context.config.overview_code}  id={this.context.config.system_code || "ERP"}/>
        {this.state.BottomNavigation && <this.state.BottomNavigation  history={this.props.history} code={"DASHBOARD"}/>}
      </div>
    )
  }
}
Home.contextType = AuthContext;
Home.propTypes={
  mediaQueryMatches: PropTypes.bool,
  history:PropTypes.any,
  location: PropTypes.any
}
class HomePage extends PureComponent{
  constructor(props){
    super(props);
    this.state={}
  }
  componentDidMount(){
    console.log("[Home] did mount");
  }
  componentDidUpdate(){
    console.log("[Home] did update");
  }
  componentWillUnmount() {
    console.log("[Home] WILL UNMOUNT");
  }
  render(){
    if(!this.context.queryParams) return null;
    return (
      <Container {...this.props} requireLogin showDrawerIfIsDesktop={true} placeholderSearch ="Tìm chức năng..."   onSearch={this.context.queryParams.for_agent?null:(q)=>{
        if(!q) return;
        this.props.history.push("/search/" + q);
      }}>
        <Home {...this.props} />
      </Container>
    )
  }
}
HomePage.contextType = AuthContext;
HomePage.propTypes={
  history: PropTypes.any,
  location: PropTypes.any
}
export default  withRouter(withMediaQuery('(max-width:540px)')(HomePage));
